module.exports = __webpack_public_path__ + "img/applyclose.6a4a54cc.svg";